﻿//Jquery
import "./jquery-global.js";
import $ from "jquery";
import {initiate_Carousels} from "./carousels";
import {initiateVatToggle} from "./vat-toggle";
import {initAddToCart} from "./add-to-cart";
import {initiateComponents, initiateQuantityInputs} from "./initializeComponents";
import {initShortListOperation} from "./shortlist";

export function initiateProductPage() {

    // change url when variant picked
    $(document).on('change', '[data-product-variant-select]', async function (event) {
        const productId = $(this).data('product-variant-select');
        const variantId = $(this).val();
        const result = await fetch(`/pv/${productId}/${variantId}`)
        if (result.ok) {
            // set query string to new variantId
            const url = new URL(window.location);
            url.searchParams.set('variantId', variantId);
            window.history.pushState({}, '', url);

            const holder = $('[data-multi-variant-product]');
            holder.html(await result.text());
            
            // update title 
            const pageTitle = holder.find('[data-page-title]').val();
            if (pageTitle) {
                document.title = pageTitle;
            }

            initiate_Carousels();
            initiateVatToggle();
            initAddToCart();
            initiateComponents();
            initShortListOperation();
        }
    })


}
